import { Pipe, PipeTransform } from '@angular/core';
import {
  InvoiceStatus,
  PersonInvoiceModel,
} from 'src/app/people/profile/profile-payments/person-invoice-model';

@Pipe({
  name: 'invoiceDisplay',
})
export class InvoiceDisplayPipe implements PipeTransform {
  transform(invoice: PersonInvoiceModel): InvoiceValueDisplay[] {
    if (InvoiceStatus[invoice.invoiceStatus] !== InvoiceStatus.Paid) {
      return invoice.paymentType === 'Check'
        ? [{ paymentTypeValue: 'Check Pending', cssClass: null }]
        : [{ paymentTypeValue: 'Pending', cssClass: null }];
    }
    if (invoice.paymentType === 'Check') {
      return [
        { paymentTypeValue: invoice.paymentType, cssClass: 'invoice_institution' },
        { paymentTypeValue: `${invoice.nameOnCheck}, ${invoice.checkNumber}`, cssClass: null },
      ];
    }
    return invoice.institution
      ? [
          { paymentTypeValue: invoice.institution, cssClass: 'invoice_institution' },
          { paymentTypeValue: invoice.paymentLastFour, cssClass: null },
        ]
      : [{ paymentTypeValue: 'Stripe', cssClass: null }];
  }
}

interface InvoiceValueDisplay {
  paymentTypeValue: string;
  cssClass: string;
}
